import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-content',
  imports: [CommonModule],
  templateUrl: './card-content.component.html',
  styleUrl: './card-content.component.scss',
})
export class CardContentComponent {
  @Input()
  public icon: string;
  @Input()
  public currency: string;
  @Input()
  public calculation: number;
  @Input()
  public periodName: string;
  @Input()
  public title: string;
  @Input()
  public detailedCalculation: { label: string; value: number }[];
  @Input()
  public calculationSummary: { label: string; value: number };
}
